import { ArrowUpRight } from "lucide-react";
import { ICONS } from "@/lib/data";

export default function ServiceCard({ service, onSelect, index = 0, region, animate = true }) {
    const Icon = ICONS[service.icon] || ICONS.BookOpen;
    return (
        <article
            data-testid={`service-card-${service.slug}`}
            className={`card-3d p-7 md:p-8 relative ${animate ? "animate-fade-up" : ""} flex flex-col h-full`}
            style={animate ? { animationDelay: `${index * 60}ms` } : undefined}
        >
            <div className="flex items-start justify-between mb-6">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-brand-creamLight text-brand-ink">
                    <Icon size={22} strokeWidth={1.6} />
                </span>
                {region && (
                    <span className="text-[10px] uppercase tracking-[0.2em] text-brand-muted">
                        {region}
                    </span>
                )}
            </div>
            <h3 className="font-serif text-2xl text-brand-ink leading-tight mb-3">{service.title}</h3>
            <p className="text-sm text-brand-muted leading-relaxed mb-5">{service.summary}</p>
            <ul className="space-y-2 mb-6 text-sm text-brand-ink/85">
                {service.bullets.slice(0, 4).map(b => (
                    <li key={b} className="flex gap-2.5">
                        <span className="mt-1.5 inline-block w-1.5 h-1.5 rounded-full bg-brand-amber shrink-0" />
                        <span>{b}</span>
                    </li>
                ))}
            </ul>
            {service.idealFor && (
                <p className="text-xs text-brand-muted mb-5">
                    <span className="font-semibold text-brand-ink">Ideal for:</span> {service.idealFor}
                </p>
            )}
            <button
                type="button"
                onClick={() => onSelect && onSelect(service)}
                data-testid={`service-learn-more-${service.slug}`}
                className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-brand-ink link-underline self-start"
            >
                Learn more <ArrowUpRight size={16} />
            </button>
        </article>
    );
}
